const trackedEvents = new Set();

export const pushDataLayerEventOnce = (eventName, parameters = {}) => {
  const eventKey = parameters.signup_step
    ? `${eventName}_${parameters.signup_step}`
    : eventName;
  const storageKey = `ksol_analytics_${eventKey}`;

  if (trackedEvents.has(eventKey)) {
    return false;
  }

  try {
    if (sessionStorage.getItem(storageKey) === "true") {
      trackedEvents.add(eventKey);
      return false;
    }
  } catch (error) {
    // Tracking should still work when browser storage is unavailable.
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...parameters,
  });
  trackedEvents.add(eventKey);

  try {
    sessionStorage.setItem(storageKey, "true");
  } catch (error) {
    // The in-memory guard still prevents duplicate events on this page.
  }

  return true;
};

export const trackFreeDownloadSignupComplete = () =>
  pushDataLayerEventOnce("free_download_signup_complete", {
    signup_type: "free_downloads",
  });

export const trackFreeDownloadSignupStep = (signupStep, stepNumber) =>
  pushDataLayerEventOnce("free_download_signup_step", {
    signup_type: "free_downloads",
    signup_step: signupStep,
    step_number: stepNumber,
  });
